import { RxCrossCircled } from "react-icons/rx";
import logo from '../assets/Deli_Logo.svg'

const PopUpMLSError = ({ setMLSError }) => {
    
    return ( 
        <div className='flex z-30 justify-center lg:pt-[10%] w-full fixed lg:absolute bottom-[35%] lg:bottom-auto'>
            <div className='flex flex-col px-10 py-10 bg-white rounded-2xl gap-5 w-[90%] md:w-[50%] xl:w-[30%]'>
                <div id='header' className='flex justify-end items-center'>
                    <div onClick={() => setMLSError(false)} className='flex justify-end cursor-pointer'>
                        <RxCrossCircled className='text-gray-500' size={18} />
                    </div>
                </div>
                <div className='flex items-center flex-col gap-1'>
                    <div >
                        <img width={80} src={logo} alt="" />
                    </div>
                    <br></br>
                    <h2 className="text-black font-semibold text-5xl text-center w-70 mb-3">
                        Hey there!
                    </h2>
                    <p className="text-[14px] lg:max-w-[70%] md:max-w-[75%] text-center mb-3">
                        Unfortunately we have not yet partnered with your MLS yet, but we would like to!
                    </p>
                    <p className="text-[14px] lg:max-w-[70%] md:max-w-[75%] text-center">
                        A Deli staff member will reach-out to you soon to see how we can work together.
                    </p>
                </div>
                <div className='flex items-center lg:gap-16'>
                    <button
                        onClick={() => setMLSError(false)}
                        type="button"
                        className='text-md py-4 rounded-full w-full flex justify-center items-center bg-[#0062FF] text-white px-5 transition-transform duration-300 hover:scale-105'
                    >
                        BACK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PopUpMLSError;
